import {atom} from 'recoil';

export const loadingState = atom({
    key: 'loadingState',
    default: {
        active: false,
        text: ''
    }
});